import { z } from 'zod';

export const applyRevisionDataSchema = z.object({
	revisionDataFile: z.instanceof(File, { message: 'A valid file must be uploaded.' })
});

export type MeasurementGroupApplyRevisionFormType = z.infer<typeof applyRevisionDataSchema>;
